export default __webpack_public_path__ + "static/media/bitbank-verified.b458d49e.svg";